<template>
  <section class="trust-band" aria-label="Réassurance">
    <div class="container">
      <ul class="trust-band__list">
        <li v-for="item in items" :key="item.title" class="trust-band__item">
          <span class="trust-band__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
              <path :d="item.path" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span class="trust-band__text">
            <strong>{{ item.title }}</strong>
            <span v-if="item.sub">{{ item.sub }}</span>
          </span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup>
/** Claims non chiffrés — pas de métriques inventées */
const items = [
  {
    title: 'Patrimonea',
    sub: 'Expertise patrimoniale',
    path: 'M12 3l8 4v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V7l8-4z',
  },
  {
    title: 'Conseiller dédié',
    sub: 'Accompagnement humain',
    path: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM20 8v6M23 11h-6',
  },
  {
    title: 'Confidentialité',
    sub: 'Cadre contractuel',
    path: 'M4 7h16v10H4zM8 7V5a4 4 0 0 1 8 0v2',
  },
];
</script>

<style scoped>
.trust-band {
  background: var(--paper, #fff);
  border-bottom: 1px solid rgba(1, 38, 62, 0.08);
  padding: 1.25rem 0;
}

.trust-band__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 1.25rem;
}

@media (min-width: 992px) {
  .trust-band__list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1.5rem;
  }
}

.trust-band__item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.trust-band__icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-brown-soft);
  color: var(--brand-brown);
  display: grid;
  place-items: center;
}

.trust-band__icon svg {
  width: 18px;
  height: 18px;
}

.trust-band__text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  font-size: 0.8rem;
  line-height: 1.35;
  color: var(--muted, #5a6a75);
}

.trust-band__text strong {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--brand-navy, #01263e);
}
</style>
